import * as React from "react";

function SvgIcons8Private(props, ref) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...{ ...props, ref }}>
      <path d="M16 4C9.383 4 4 9.383 4 16s5.383 12 12 12 12-5.383 12-12S22.617 4 16 4zm0 2c5.535 0 10 4.465 10 10s-4.465 10-10 10S6 21.535 6 16 10.465 6 16 6zm0 3v6h2V9zm-3 1v6h2v-6zm6 0v9c0 .023-.004.418-.375.906-.09.121-.2.254-.344.375-.46.383-1.261.719-2.781.719-1.922 0-2.633-.742-3.063-1.5C12.008 18.742 12 18 12 18v-6h-2v6s.016 1.258.719 2.5S12.977 23 15.5 23c1.96 0 3.3-.598 4.156-1.344l.063.063 5-5-1.438-1.438L21 17.562V10z" />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8Private);
